import { FoodTypeResponse,AllFoodTypesResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler, errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { FoodTypeRequest } from './dto/food-type.request';
import { FoodTypeDTO } from './dto/food-types.dto';
import { FoodType } from './food-types.entitiy';
import { FoodTypesService } from './food-types.service';


@ApiTags('food-type')
@Controller('food-type')
export class FoodTypesController {
  constructor(
    private foodTypeService: FoodTypesService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler,
  ) {}


   /**
     * creates or updates a FoodType
     * @param FoodType FoodType DTO
     * @returns FoodTypeResponse
     */
    @Post('/createFoodType')
    async createFoodType(@Body() foodTypesDto:FoodTypeDTO,isUpdate:boolean=false,@Req() request:Request): Promise<FoodTypeResponse> {
        try {
         return await this.foodTypeService.createFoodType(foodTypesDto,false,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(FoodTypeResponse, error);
       }
     }

     /**
     * gets all the Food Types
     * @returns AllFoodTypesResponseModel which returns all the Food Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

    @Post('/getAllFoodTypes')
    async getAllFoodTypes(@Body() req?:UserRequestDto): Promise<AllFoodTypesResponse> {
        try {
            return await this.foodTypeService.getAllFoodTypes(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllFoodTypesResponse, error);
        }
    }
    @Post('/getAllActiveFoodTypes')
  async getAllActiveFoodTypes(@Req() request: Request): Promise<AllFoodTypesResponse> {
      try {
          return await this.foodTypeService.getAllActiveFoodTypes();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllFoodTypesResponse, error)
      }
  }

     /**
     * Activate Or De-Activate Food Type
     * @param getSingleFoodType 
     * @returns FoodTypeResponse
     */
   @Post('/activateOrDeactivateFoodType')
   async activateOrDeactivateFoodType(@Body() foodTypeRequest: FoodTypeRequest): Promise<FoodTypeResponse> {
       try {
           return await this.foodTypeService.activateOrDeactivateFoodType(foodTypeRequest);
       } catch (err) {
           console.log(err);
           return this.applicationExceptionHandler.returnException(FoodTypeResponse, err);
       }
   }

   /**
     * creates or updates a FoodType
     * @param FoodType FoodType DTO
     * @returns FoodTypeResponse
     */
    @Post('/updateFoodType')
    async updateFoodType(@Body() foodTypesDto:FoodTypeDTO,@Req() request:Request): Promise<FoodTypeResponse> {
        try {
         return await this.foodTypeService.createFoodType(foodTypesDto,true,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(FoodTypeResponse, error);
       }
     }
     @Post('/getFoodTypeDataById')
    async getFoodTypeDataById(@Body() foodTypeRequest:FoodTypeRequest,@Req() request: Request): Promise<FoodTypeResponse> {
        try {
        return await this.foodTypeService.getFoodTypeDataById(foodTypeRequest);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FoodTypeResponse, error)
        }
    }



}
function AllFoodTypesResponseModel(AllFoodTypesResponseModel: any, error: any): any {
  throw new Error('Function not implemented.');
}

